import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {
  EnvironmentInjector,
  inject,
  runInInjectionContext,
} from '@angular/core';
import {EpgStatusDialogService} from '@epg-apps/epg-status-dialog';
import {catchError, throwError} from 'rxjs';
import {EPG_AUTHENTICATOR_CONFIG} from './epg-authenticator-config';

export const epgHttpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const environmentInjector = inject(EnvironmentInjector);
  const config = inject(EPG_AUTHENTICATOR_CONFIG);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      switch (error.status) {
        case 403:
        case 401:
          if (config.authenticationUrl) {
            window.location.href = config.authenticationUrl;
          } else {
            showHttpErrorStatusDialog(environmentInjector, {
              ...error,
              statusText: 'Authentication URL not configured',
              message:
                'Please configure EPG_AUTHENTICATOR_CONFIG with an authenticationUrl',
            } as HttpErrorResponse);
          }
          break;
        default:
          showHttpErrorStatusDialog(environmentInjector, error);
      }

      return throwError(() => error);
    }),
  );
};

export function showHttpErrorStatusDialog(
  environmentInjector: EnvironmentInjector,
  error: HttpErrorResponse,
) {
  runInInjectionContext(environmentInjector, () => {
    inject(EpgStatusDialogService).open({
      title: error.statusText,
      statusCode: error.status,
      htmlContent: '',
      dismissLabel: 'OK',
    });
  });
}
